/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import { Close } from "@mui/icons-material";
import { Alert, Box, Button, IconButton, keyframes } from "@mui/material";
import { PutCacheMutation } from "components/gql/mutations/PutCache";
import { GetChannelsQuery } from "components/gql/queris/GetChannels";
import { GetEquipmentsQuery } from "components/gql/queris/GetEquipments";
import { GetData } from "contexts/DataContext";
import {
  getFirstInArray,
  isObjectEmpty,
  putCacheFunc,
  saveStringify,
} from "data/functions";
// import { useAuth } from "react-oidc-context";
import { usePWAInstall } from "react-use-pwa-install";
import { GetAlertData } from "./AlertContext";
import { GetCInfo } from "./CompanyContext";

// import { GetAuthData } from "contexts/TAuthContext";
// import { gqlReducer } from "data/globals";

export const GQLContext = React.createContext();

function GQLProvider({ children }) {
  const { dataObj, forceSetDataObj } = GetData();
  const { cInfo } = GetCInfo();
  const { setAlert } = GetAlertData();
  // const auth = useAuth();
  const [equipmentQuery] = GetEquipmentsQuery();
  const [channelsQuery] = GetChannelsQuery();
  const [putCacheMutation] = PutCacheMutation();

  useEffect(() => {
    if (cInfo?.UUID && dataObj?.token && dataObj?.userID) {
      equipmentQuery({
        variables: {
          companyUuid: cInfo?.UUID,
          idmUserUuid: dataObj?.userID,
        },
      });
    }

    // eslint-disable-next-line
  }, [cInfo?.UUID, dataObj?.userID, dataObj?.token]);

  useEffect(() => {
    if (!isObjectEmpty(cInfo?.UUID)) {
      channelsQuery({
        variables: {
          companyUuid: cInfo?.UUID,
        },
      });
    }
    // eslint-disable-next-line
  }, [cInfo?.UUID]);

  useEffect(() => {
    if (
      !isObjectEmpty(dataObj?.equipments) &&
      (isObjectEmpty(dataObj?.usedEquipment) ||
        !dataObj.equipments.find((el) => el?.ID === dataObj?.usedEquipment?.ID))
    ) {
      let newEquip = getFirstInArray(dataObj?.equipments);
      forceSetDataObj(newEquip, "usedEquipment");
      if (dataObj?.payType !== "self-service") {
        setAlert(`Выбрано оборудование:\n ${newEquip?.name}`, "info");
      }
    }

    if (dataObj?.usedEquipment !== undefined)
      putCacheFunc("usedEquipment", dataObj?.usedEquipment, putCacheMutation);

    // eslint-disable-next-line
  }, [dataObj?.usedEquipment, dataObj?.equipments]);

  useEffect(() => {
    if (dataObj?.themeMode !== undefined)
      putCacheFunc("themeMode", dataObj?.themeMode, putCacheMutation);
    // eslint-disable-next-line
  }, [dataObj?.themeMode]);

  useEffect(() => {
    if (dataObj?.refreshRate !== undefined)
      putCacheFunc("refreshRate", dataObj?.refreshRate, putCacheMutation);
    // eslint-disable-next-line
  }, [dataObj?.refreshRate]);

  useEffect(() => {
    if (dataObj?.zoom !== undefined)
      putCacheFunc("zoom", dataObj?.zoom, putCacheMutation);
    // eslint-disable-next-line
  }, [dataObj?.zoom]);

  useEffect(() => {
    if (dataObj?.disablePayButton !== undefined)
      putCacheFunc(
        "disablePayButton",
        dataObj?.disablePayButton,
        putCacheMutation
      );
    // eslint-disable-next-line
  }, [dataObj?.disablePayButton]);

  useEffect(() => {
    if (dataObj?.pin !== undefined)
      putCacheFunc("pin", dataObj?.pin ?? "", putCacheMutation);
    // eslint-disable-next-line
  }, [dataObj?.pin]);

  useEffect(() => {
    if (dataObj?.payType !== undefined)
      putCacheFunc("payType", dataObj?.payType ?? "payment", putCacheMutation);
    // eslint-disable-next-line
  }, [dataObj?.payType]);

  useEffect(() => {
    putCacheFunc(
      "cameraType",
      dataObj?.cameraType ?? "front",
      putCacheMutation
    );
    // eslint-disable-next-line
  }, [dataObj?.cameraType]);

  return (
    <GQLContext.Provider
      // value={contextValue}
      value={""}
    >
      {children}
      <PWAContext />
    </GQLContext.Provider>
  );
}
export const GetGQLContext = () => {
  try {
    const context = React.useContext(GQLContext);
    return context;
  } catch {
    return "";
  }
};

export { GQLProvider };

export function PWAContext(props) {
  const { dataObj, setDataObj } = GetData();
  const { setAlert } = GetAlertData();
  const [open, setOpen] = React.useState(false);
  const install = usePWAInstall();

  async function getStorage() {
    // check if Storage API is supported
    const supported = "storage" in navigator;

    // check if persistent storage is supported
    const persistentStorageSupported =
      navigator.storage && navigator.storage.persist;

    if (persistentStorageSupported) {
      navigator.storage.persist().then((persistent) => {
        if (persistent) {
          //   setAlert(
          //     "Storage will not be cleared except by explicit user action"
          // );
        } else {
          // setAlert("Storage may be cleared by the UA under storage pressure.");
        }
      });
    }
    // request persistent storage
    const persist = await navigator.storage.persist();

    // check if app already has persistent storage
    const hasPersistentStorage = await navigator.storage.persisted();

    // get usage statistics
    const { quota, usage, usageDetails } = await navigator.storage.estimate();
  }

  React.useEffect(() => {
    getStorage();
  }, []);

  React.useEffect(() => {
    if (install && typeof install === "function" && !dataObj?.PWADisagree) {
      // test();
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
      }, 30 * 1000);
    }
    return () => setOpen(false);
  }, [install]);

  return (
    <React.Fragment>
      {open && (
        <Alert
          action={
            <Box sx={{ display: "flex", flexDirection: "row", gap: "6px" }}>
              <Button
                // color="info"
                onClick={() => {
                  install();
                  // setDataObj(true, "PWADisagree");
                }}
                size="small"
                sx={{ fontWeight: 500 }}
                variant="contained"
              >
                Добавить
              </Button>
              <IconButton
                onClick={() => {
                  setOpen(false);
                  setDataObj(true, "PWADisagree");
                }}
                size="small"
                sx={{ fontWeight: 500 }}
                variant="contained"
              >
                <Close fontSize="inherit" />
              </IconButton>
            </Box>
          }
          icon={false}
          onClose={() => {
            // setAlertArray((e) => e.filter((v) => v?.id !== el?.id));
          }}
          severity={"info"}
          sx={{
            ".MuiAlert-action": {
              marginLeft: "unset",

              alignItems: "center",
              justifyContent: "center",
            },
            ".MuiAlert-message": {
              marginLeft: "auto",
              marginRight: "auto",
              textWrap: "balance",
            },
            animation: `${appear} .4s ease-in-out`,
            background: "#4d575c",
            bottom: "24px",
            color: "#fff",
            // left: isMobile ? "0" : "256px",
            justifyContent: "center",
            // left: dataObj?.deviceWidth?.isMobile ? "0" : "256px",
            // padding: "2px",
            position: "absolute",
            textAlign: "center",
            whiteSpace: "pre-line",
            width: "100%",
            zIndex: 2000,
          }}
          variant="filled"
        >
          Добавить ярлык на рабочий стол?
        </Alert>
      )}
    </React.Fragment>
  );
}

export const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
